import React from 'react'
import ImageGallery from 'react-image-gallery'

const ImageCarousel = ({images}) => {
    let items = images.map((image, index) => {
        return ({
            original: image.url,
            thumbnail: image.url
        })
    })
    return(
        <ImageGallery 
            items={items} 
        />
    )
}

export default ImageCarousel